export enum StudentPracticeExamAssessmentStatusEnum {
  /// <summary>
  /// Not specified (always open)
  /// </summary>
  Unspecified = 0,

  /// <summary>
  /// Available to buy
  /// </summary>
  AvailableToBuy = 1,

  /// <summary>
  /// To be released
  /// </summary>
  ToBeReleased = 2,

  /// <summary>
  /// Released (but not started)
  /// </summary>
  ReleasedNotStarted = 3,

  /// <summary>
  /// Start (but not finished)
  /// </summary>
  StartedNotFinished = 4,

  /// <summary>
  /// Finished
  /// </summary>
  Finished = 5,

  /// <summary>
  /// Not done in availability time range
  /// </summary>
  NotDone = 6,

  /// <summary>
  /// Unavailable
  /// </summary>
  Unavailabled = 7,

  /// <summary>
  /// Blocked
  /// </summary>
  Blocked = 8,
}
